import { api } from './request'

export interface AdminUser {
  id: number
  email: string
  username: string
  display_name: string
  avatar: string
  bio: string
  website: string
  company: string
  location: string
  email_verified: boolean
  status: number
  created_at: string
  updated_at: string
}

export const adminApi = {
  // Admin login (dedicated admin login API)
  login(email: string, password: string) {
    return api.post('/admin/login', { email, password })
  },

  listUsers(page = 1, pageSize = 20, search = '') {
    return api.get<{ list: AdminUser[]; total: number; page: number; page_size: number }>(
      '/admin/users',
      { params: { page, page_size: pageSize, search } }
    )
  },

  updateUser(id: number, data: Partial<AdminUser>) {
    return api.put<AdminUser>(`/admin/users/${id}`, data)
  },

  getDownloadAnalytics(days = 30) {
    return api.get<{
      days: number
      summary: { date: string; count: number }[]
      by_repo: { date: string; repository_id: number; repo_name: string; count: number }[]
    }>('/admin/analytics/downloads', { params: { days } })
  },

  getPageViewAnalytics(days = 30) {
    return api.get<{
      days: number
      pv_summary: { date: string; count: number }[]
      uv_summary: { date: string; count: number }[]
      total_uv: number
      prev_pv: number
      prev_uv: number
      new_visitors: { date: string; count: number }[]
      bounce_rate: { date: string; rate: number }[]
      total_bounce_rate: number
      sources: { name: string; count: number }[]
      devices: { name: string; count: number }[]
      countries: { name: string; count: number }[]
      hourly: { hour: number; count: number }[]
      landing_pages: { path: string; count: number }[]
      referers: { domain: string; count: number }[]
      retention: { date: string; rate: number }[]
    }>('/admin/analytics/pageviews', { params: { days } })
  },
}

export default adminApi
